import { EInfrastructureActionType, ISetFeaturesStatusPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setFeaturesStatus = actionGenerator<
  EInfrastructureActionType.SetFeaturesStatus,
  ISetFeaturesStatusPayload
>(EInfrastructureActionType.SetFeaturesStatus);
